import { API } from "shared/constants/AppEnums"

export const getComposerDigisign = async (tipe, param, page = 0, limit) => {
    try {
        let url = ''
        if (tipe.includes('dokumen_pkrl')) {
            let type = tipe.split('|')[0]
            let direktorat = tipe.split('|')[1]

            url = API.GET_LIST_COMPOSER.replace('$tipe', type).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${param}` + `&direktorat=${direktorat}`
        } else {
            url = API.GET_LIST_COMPOSER.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${param}`
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDraftDigisign = async (tipe, general, page = 0, limit) => {
    try {
        let url = ''
        if (tipe.includes('dokumen_pkrl')) {
            let type = tipe.split('|')[0]
            let direktorat = tipe.split('|')[1]

            url = API.GET_LIST_DRAFT.replace('$tipe', type).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}` + `&direktorat=${direktorat}`
        } else {
            url = API.GET_LIST_DRAFT.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}`
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getInboxPK = async (tipe, general, page = 0, limit) => {
    try {

        const response = await fetch(API.GET_LIST_INBOX_PK.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getApprovalSK = async (tipe, general, page = 0, limit) => {
    try {
        console.log(API.GET_LIST_APPROVAL_SK)
        const response = await fetch(API.GET_LIST_APPROVAL_SK.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getNeedSignSK = async (tipe, general, page = 0, limit) => {
    try {
        const response = await fetch(API.GET_LIST_NEED_SIGN_SK.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getInprogressDigisign = async (tipe, general, page = 0, limit) => {
    try {
        let url = ''
        if (tipe.includes('dokumen_pkrl')) {
            let type = tipe.split('|')[0]
            let direktorat = tipe.split('|')[1]

            url = API.GET_LIST_INPROGRESS.replace('$tipe', type).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}` + `&direktorat=${direktorat}`
        } else {
            url = API.GET_LIST_INPROGRESS.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}`
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getReadyDigisign = async (tipe, general, page = 0, limit) => {
    try {
        const response = await fetch(API.GET_LIST_READY.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getCompletedDigisign = async (tipe, general, page = 0, limit) => {
    try {
        let url = ''
        if (tipe.includes('dokumen_pkrl')) {
            let type = tipe.split('|')[0]
            let direktorat = tipe.split('|')[1]

            url = API.GET_LIST_COMPLETED.replace('$tipe', type).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}` + `&direktorat=${direktorat}`
        } else {
            url = API.GET_LIST_COMPLETED.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}`
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getNumberDigisign = async (tipe, param, page = 0, limit) => {
    try {
        let url = ''
        if (tipe.includes('dokumen_pkrl')) {
            let type = tipe.split('|')[0]
            let direktorat = tipe.split('|')[1]

            url = API.GET_LIST_GET_NUMBER.replace('$tipe', type).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${param}` + `&direktorat=${direktorat}`
        } else {
            url = API.GET_LIST_GET_NUMBER.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${param}`
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getRevisionDigisign = async (tipe, param, page = 0, limit) => {
    try {
        let url = ''
        if (tipe.includes('dokumen_pkrl')) {
            let type = tipe.split('|')[0]
            let direktorat = tipe.split('|')[1]

            url = API.GET_LIST_REVISION.replace('$tipe', type).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${param}` + `&direktorat=${direktorat}`
        } else {
            url = API.GET_LIST_REVISION.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${param}`
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getCompletedDigisignSk = async (tipe, general, page = 0, limit) => {
    try {
        const response = await fetch(API.GET_LIST_COMPLETED.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit).replace("completed", "sk-completed") + `&general=${general}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDetailDigisign = async (id, isMonitoring) => {
    try {
        let url = API.GET_DETAIL_DIGISIGN.replace('$id', id) + `${isMonitoring ? '?all=true' : ''}`
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDocumentCounter = async (type) => {
    try {
        console.log(API.GET_DOKUMEN_COUNTER)
        const response = await fetch(API.GET_DOKUMEN_COUNTER + "?type=" + type, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDetailDraftDigisign = async (id) => {
    try {
        const response = await fetch(API.UPDATE_DOKUMEN_DIGISIGN.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addDocumentDigiSign = async (data, type) => {
    try {
        const response = await fetch(type === 'bankom' ? API.ADD_DOCUMENT_BANKOM_DIGISIGN : API.ADD_DOCUMENT_DIGISIGN, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addDocumentDigiSignPk = async (file) => {
    try {
        const formData = new FormData()
        formData.append("file", file)
        formData.append("name", "PK_" + file.name)

        const response = await fetch(API.ADD_DOCUMENT_DIGISIGN_PK, {

            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
            body: formData
        })
        return response.json()
    } catch (error) {
        return error
    }
}




export const approveDocumentDigiSign = async (data) => {
    try {
        const response = await fetch(API.PUT_INPROGRESS_DOKUMENSK_DIGISIGN, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const rejectDokumenDigiSign = async (data) => {
    try {
        const response = await fetch(API.REJECT_DOCUMENT_DIGISIGN, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putDocumentDigiSign = async (data, id) => {
    try {
        const response = await fetch(API.PUT_DOCUMENT_DIGISIGN.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}


export const putDocumentDigiSignPk = async (data, id) => {
    try {
        const response = await fetch(API.PUT_DOCUMENT_DIGISIGN_PK.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putDocumentPkReturn = async (data) => {
    try {
        const response = await fetch(API.PUT_DOCUMENT_DIGISIGN_RETURN_PK, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putDocumentPkCancel = async (data) => {
    try {
        const response = await fetch(API.PUT_DOCUMENT_DIGISIGN_CANCEL_PK, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putDocumentSkReturn = async (data) => {
    try {
        const response = await fetch(API.PUT_DOCUMENT_DIGISIGN_RETURN_SK, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}


export const putDocumentSkRevision = async (data) => {
    try {
        const response = await fetch(API.PUT_DOCUMENT_DIGISIGN_RETURN_SK.replace("return", "revision"), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}


export const putDocumentSkReject = async (data) => {
    try {
        const response = await fetch(API.PUT_DOCUMENT_DIGISIGN_RETURN_SK.replace("return", "reject"), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addAttachmentDigisign = async (file) => {
    try {
        var formData = new FormData()
        formData.append("file", file)
        formData.append("name", file.name)
        const response = await fetch(API.ADD_ATTACHMENT_DIGISIGN, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
            body: formData
        })
        return response.json()
    } catch (error) {
        return error
    }
}


export const addAttachmentDigisignSk = async (type, file) => {
    try {
        var formData = new FormData()
        console.log(file)
        formData.append("file", file)
        formData.append("name", type + "_" + file.name)
        const response = await fetch(API.ADD_ATTACHMENT_DIGISIGN, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
            body: formData
        })
        return response.json()
    } catch (error) {
        return error
    }
}


export const putApprove = async (payload, type) => {
    try {
        const response = await fetch(type === 'bankom' ? API.PUT_INPROGRESS_BANKOM_DIGISIGN : API.PUT_INPROGRESS_DOKUMENLAIN_DIGISIGN, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return response.json()
    } catch (error) {
        return error
    }
}


export const putRelease = async (payload, type, id) => {
    try {
        const response = await fetch(API.GET_DETAIL_DIGISIGN.replace("$id", id) + "/release/", {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getListCourseDigisign = async (limit) => {
    try {
        const response = await fetch(API.GET_LIST_COURSE_DIGISIGN + limit, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            },
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDetailCourseDigisign = async (id) => {
    try {
        const response = await fetch(API.GET_DETAIL_COURSE_DIGISIGN.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            },
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getPenerimaSertifikatByCourse = async (id) => {
    try {
        const response = await fetch(API.GET_PENERIMA_SERTIF_BY_COURSE.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getRejectedDigisign = async (param, page = 0) => {
    try {
        const response = await fetch(API.GET_LIST_REJECTED_DIGISIGN.replace('$page', page == 0 ? 1 : page) + `&general=${param}&tipe_dokumen=dokumen_lain`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getRejectedDigisignSk = async (tipe, param, page = 0) => {
    let tipeParam = tipe === '' ? 'dokumen_sk' : tipe
    try {
        const response = await fetch(API.GET_LIST_REJECTED_DIGISIGN.replace('$page', page == 0 ? 1 : page) + `&general=${param}&tipe_dokumen=${tipeParam}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getRevisiDigisignSk = async (tipe, param, page = 0) => {
    let tipeParam = tipe === '' ? 'dokumen_sk' : tipe
    try {
        const response = await fetch(API.GET_LIST_REVISI_DIGISIGN.replace('$page', page == 0 ? 1 : page) + `&general=${param}&tipe_dokumen=${tipeParam}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getRejectedDigisignPk = async (param, page = 0) => {
    try {
        const response = await fetch(API.GET_LIST_REJECTED_DIGISIGN.replace('$page', page == 0 ? 1 : page) + `&general=${param}&tipe_dokumen=dokumen_pk`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getRejectedPerizinanDigisign = async (param, page = 0) => {
    try {
        const response = await fetch(API.GET_LIST_REJECTED_PERIZINAN_DIGISIGN.replace('$page', page == 0 ? 1 : page) + `&general=${param}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSignedDigisign = async (tipe, param, page = 0, limit) => {
    try {
        let url = ''
        if (tipe.includes('dokumen_pkrl')) {
            let type = tipe.split('|')[0]
            let direktorat = tipe.split('|')[1]

            url = API.GET_LIST_SIGNED_DIGISIGN.replace('$tipe', type).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${param}` + `&direktorat=${direktorat}`
        } else {
            url = API.GET_LIST_SIGNED_DIGISIGN.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${param}`
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getRetryDigisign = async (tipe, param, page = 0, limit) => {
    try {
        const response = await fetch(API.GET_LIST_RETRY_DIGISIGN.replace('$tipe', tipe).replace('$page', page == 0 ? 1 : page) + `&general=${param}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSummaryCount = async () => {
    try {
        const response = await fetch(API.GET_SUMMARY_COUNT, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSummaryList = async (page, jenisSertifikat, pelatihan, judulPelatihan) => {
    try {
        const url = page === 1 ? API.GET_SUMMARY_LIST.replace('page=$page&', '').replace('$sertifikat', jenisSertifikat).replace('$pelatihan', pelatihan).replace('$judulPelatihan', judulPelatihan) : API.GET_SUMMARY_LIST.replace('$page', page).replace('$sertifikat', jenisSertifikat).replace('$pelatihan', pelatihan).replace('$judulPelatihan', judulPelatihan)
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSubjectList = async (pelatihan) => {
    try {
        const response = await fetch(API.GET_SUBJECT_LIST.replace('$pelatihan', pelatihan), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getExportSummaryList = async (judulPelatihan) => {
    try {
        const response = await fetch(API.GET_EXPORT_SUMMARY_LIST.replace('$judulPelatihan', judulPelatihan), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getTemplateTitikDigisign = async () => {
    try {
        const response = await fetch(API.GET_TEMPLATE_DIGISIGN, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const checkPDFDigisign = async (payload) => {
    try {
        const response = await fetch(API.CHECK_PDF_DIGISIGN, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putEvaluasiDigisign = async (payload, id) => {
    try {
        const response = await fetch(API.UPDATE_EVALUASI_DIGISIGN.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSertifikatExternal = async (page, limit, type) => {
    try {
        const response = await fetch(API.GET_SERTIFIKAT_EXTERNAL.replace('$page', page).replace('$limit', limit).replace('$type', type), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addSertifikatExternal = async (payload) => {
    try {
        const response = await fetch(API.GET_SERTIFIKAT_EXTERNAL.replace('?page=$page', '').replace('&limit=$limit', '').replace('&type=$type', ''), {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDetailSertifikatExternal = async (id) => {
    try {
        const response = await fetch(API.GET_DETAIL_SERTIFIKAT_EXTERNAL.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}


export const getDokumenSKPYB = async () => {
    try {
        const response = await fetch(API.GET_DOKUMEN_SK_PYB, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDokumenSKPYBPPID = async () => {
    try {
        const response = await fetch(API.GET_DOKUMEN_SK_PYB_PPID, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDokumenPKPYB = async () => {
    try {
        const response = await fetch(API.GET_DOKUMEN_PK_PYB, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addAttachmentSertifikatExternalDigisign = async (file) => {
    try {
        var formData = new FormData()
        formData.append("file", file)
        const response = await fetch(API.ADD_ATTACHMENT_SERTIFIKAT_EXTERNAL_DIGISIGN, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
            body: formData
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const exportPK = async (status, isMonitoring = false) => {
    try {
        const response = await fetch(
            API.EXPORT_DOKUMEN_PK +
                '?status=' + status +
                (isMonitoring ? '&monitoring=true' : ''),
            {
                method: 'GET',
                headers: {
                    'Authorization': sessionStorage.getItem('token'),
                },
            },
        )
        return response.json()
    } catch (error) {
        return error
    }
}

export const exportSK = async (status) => {
    try {

        const response = await fetch(API.EXPORT_DOKUMEN_SK + "?status=" + status, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getBiodata = async (id) => {
    try {
        const response = await fetch(API.GET_DETAIL_PEGAWAI_SIPEG.replace(':nik', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getPerizinanEseaCount = async () => {
    try {
        const response = await fetch(API.GET_PERIZINAN_ESEA_COUNT, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getParafDigisign = async (payload) => {
    try {
        const response = await fetch(API.PARAF_DIGISIGN, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getPenomoranDigisign = async (jenis_dokumen, tanggal) => {
    try {
        const response = await fetch(API.PENOMORAN_DIGISIGN.replace('$jenis_dokumen', jenis_dokumen).replace('$tanggal', tanggal), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const rejectDokumenPerizinanDigiSign = async (data) => {
    try {
        const response = await fetch(API.REJECT_PERIZINAN_DIGISIGN, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putDocumentPerizinanDigiSign = async (data, id) => {
    try {
        const response = await fetch(API.PUT_DOCUMENT_DIGISIGN.replace('$id', id).replace('/draft/', ''), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getTrackDigisign = async (param, page = 0, limit) => {
    try {
        const response = await fetch(API.GET_LIST_TRACK_DIGISIGN.replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${param}` + '&tipe_dokumen=dokumen_pkrl', {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getPerizinanPKRLCount = async (type) => {
    try {
        const response = await fetch(API.GET_PERIZINAN_PKRL_COUNT + `?type=${type}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getParafBeforeTTDEDigisign = async (payload) => {
    try {
        const response = await fetch(API.PARAF_BEFORE_TTDE_DIGISIGN, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getListLaporanDigisign = async (param, page = 0, direktorat, kategori) => {
    try {
        const response = await fetch(API.GET_LIST_LAPORAN_PKRL.replace('$tipe', 'dokumen_pkrl').replace('$page', page == 0 ? 1 : page) + `&general=${param}&direktorat=${direktorat}&kategori=${kategori}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDownloadDashboardLaporanPKRLDigisign = async (direktorat, kategori) => {
    try {
        const response = await fetch(API.DOWNLOAD_DASHBOARD_LAPORAN_PKRL.replace('$direktorat', direktorat).replace('$kategori', kategori), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDownloadLaporanPKRLDigisign = async (filter) => {
    try {
        const response = await fetch(API.DOWNLOAD_LAPORAN_PKRL.replace('$state', filter), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const deleteDocumentDigisign = async (id) => {
    try {
        const response = await fetch(API.DELETE_DOCUMENT_DIGISIGN.replace('$id', id), {
            method: 'DELETE',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getMonitoringListDigisign = async (tipe, general, page, limit, status = '') => {
    try {
        let url =
            API.GET_MONITORING_LIST_DIGISIGN
                .replace('$type', tipe)
                .replace('$page', page == 0 ? 1 : page)
                .replace('$limit', limit) +
            `&general=${general}` +
            (status ? `&status=${encodeURIComponent(status)}` : '')
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getMonitoringDashboardDigisign = async () => {
    try {
        let url = API.GET_MONITORING_DASHBOARD_DIGISIGN
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getListDokumenLPMUKP = async (state, page, search) => {
    try {
        let url = API.GET_LIST_DOKUMEN_LPMUKP + state + `?page=${page + 1}&search=${search}`
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDetailDokumenLPMUKP = async (id) => {
    try {
        let url = API.GET_DETAIl_DOKUMEN_LPMUKP.replace('$id', id);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const submitDokumenLPMUKP = async (id, state, payload) => {
    try {
        let url = API.GET_DETAIl_DOKUMEN_LPMUKP.replace('$id', id).replace('$state', state);
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDashboardCountDokumen = async (filterBy, param) => {
    let url = ''
    if (filterBy === 'weekly') {
        url = API.GET_DASHBOARD_COUNT_DOKUMEN + `?date=${param}&last_7_days=true`
    } else if (filterBy === 'monthly') {
        url = API.GET_DASHBOARD_COUNT_DOKUMEN + `?monthly=${param}`
    } else if (filterBy === 'yearly') {
        url = API.GET_DASHBOARD_COUNT_DOKUMEN + `?yearly=${param}`
    }

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDigisignCount = async (type) => {
    try {
        const response = await fetch(API.GET_COUNTER_DIGISIGN.replace('$type', type), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addCSVToJSONDigisign = async (file) => {
    try {
        var formData = new FormData()
        formData.append("file", file)
        const response = await fetch(API.ADD_CSV_TO_JSON_DIGISIGN, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
            body: formData
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getComposerSMDigisign = async (param, page = 0, limit) => {
    try {
        let url = API.GET_LIST_COMPOSER_SM.replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${param}`
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getInprogressSMDigisign = async (general, page = 0, limit) => {
    try {
        let url = API.GET_LIST_INPROGRESS_SM.replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}`
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getReadySMDigisign = async (general, page = 0, limit) => {
    try {
        const response = await fetch(API.GET_LIST_READY_SM.replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getCompletedSMDigisign = async (general, page = 0, limit) => {
    try {
        let url = API.GET_LIST_COMPLETED_SM.replace('$page', page == 0 ? 1 : page).replace('$limit', limit) + `&general=${general}`
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putApproveSM = async (payload) => {
    try {
        const response = await fetch(API.PUT_INPROGRESS_SM_DIGISIGN, {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSiapMutuCount = async (isMonitoring) => {
    try {
        let url = isMonitoring ? API.GET_SIAPMUTU_COUNT + '?type=monitoring' : API.GET_SIAPMUTU_COUNT  
        const response = await fetch(url , {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getTemplateReceiversBankom = async () => {
    try {
        const response = await fetch(API.GET_TEMPLATE_RECEIVERS_BANKOM, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}